(() => {
  'use strict';
  async function init(nav) {
    if (nav.dataset.initialized || !nav.querySelector('[data-collections-more]')) return;
    nav.dataset.initialized = 'true';
    const list = nav.querySelector('.collection-navigation-list');
    const known = new Set([...list.querySelectorAll('[data-collection-handle]')].map(a => a.dataset.collectionHandle));
    const visited = new Set();
    let next = new URL(nav.dataset.collectionsSource, location.origin);
    const preview = new URL(location.href).searchParams.get('preview_theme_id');
    try {
      while (next) {
        if (next.origin !== location.origin || visited.has(next.href)) throw new Error('Invalid collection pagination');
        visited.add(next.href);
        next.searchParams.set('view', 'sidebar');
        if (preview) next.searchParams.set('preview_theme_id', preview);
        const controller = new AbortController();
        const timer = setTimeout(() => controller.abort(), 15000);
        let response;
        try { response = await fetch(next.href, {credentials: 'same-origin', signal: controller.signal}); }
        finally { clearTimeout(timer); }
        if (!response.ok) throw new Error('Collection list unavailable');
        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        const content = doc.querySelector('[data-collections-page]');
        if (!content) throw new Error('Collection list unavailable');
        content.querySelectorAll('a[data-collection-handle]').forEach(a => {
          const handle = a.dataset.collectionHandle;
          if (known.has(handle)) return;
          known.add(handle);
          a.removeAttribute('aria-current');
          if (handle === nav.dataset.currentCollection) a.setAttribute('aria-current', 'page');
          list.append(document.importNode(a.closest('li'), true));
        });
        next = content.dataset.next ? new URL(content.dataset.next, location.origin) : null;
      }
      nav.querySelector('[data-collections-more]').hidden = true;
    } catch (_) {
      // Rendered links and the full collection-list fallback remain usable.
      delete nav.dataset.initialized;
    }
  }
  const scan = () => document.querySelectorAll('[data-collection-navigation]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan);
  else scan();
  document.addEventListener('shopify:section:load', scan);
})();
